import React, { useEffect } from 'react';
import { useDeleteDocuments } from '../../networking/useDocuments';
import { DeleteFilled, EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { CheckBox } from '../base/CheckBox';
const MAX_FILENAME_LENGTH = 36;
const downloadFile = async ({ url, filename }) => {
    try {
        const response = await fetch(url);
        if (!response.ok)
            throw new Error('Network response was not ok');
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    }
    catch (error) {
        console.error('Error downloading file:', error);
    }
};
const FileEntry = ({ index, document, onChangeDocument, setIndexDocument, onDelete, onView, viewMode = false, style, actions = ['checkbox', 'view', 'delete'], }) => {
    const { data: deleteResponse, call: callDeleteDocuments } = useDeleteDocuments();
    const allowed_actions = {
        checkbox: (React.createElement(CheckBox, { key: 'checkbok-file-entry', tooltip: "Include in the task", checked: !document.isExcluded, onChange: () => {
                if (onChangeDocument)
                    onChangeDocument(document);
            } })),
        view: (React.createElement(Tooltip, { key: 'view-file-entry', className: "clickable", title: "View" },
            React.createElement(EyeOutlined, { onClick: () => {
                    if (onView) {
                        onView(document);
                    }
                    if (setIndexDocument) {
                        setIndexDocument(viewMode ? null : index);
                    }
                }, style: {} }))),
        download: (React.createElement(Tooltip, { key: 'download-file-entry', className: "clickable", title: "Download" },
            React.createElement(DownloadOutlined, { onClick: () => downloadFile({ url: document.url, filename: document.filename }) }))),
        delete: (React.createElement(Tooltip, { key: 'delete-file-entry', className: "clickable", title: "Delete" },
            React.createElement(DeleteFilled, { style: { color: 'red' }, onClick: () => callDeleteDocuments({ entity_ids: [document.id] }) }))),
    };
    useEffect(() => {
        if (deleteResponse && onDelete) {
            onDelete(deleteResponse);
        }
    }, [deleteResponse]);
    return (React.createElement("div", { style: {
            display: 'flex',
            width: '100%',
            minHeight: 32,
            flexDirection: 'row',
            padding: 8,
            alignItems: 'center',
            ...style,
        } },
        React.createElement("div", { style: { width: '80%', fontSize: 14 } }, document.filename.length > MAX_FILENAME_LENGTH
            ? `${document.filename.substring(0, MAX_FILENAME_LENGTH)}...`
            : document.filename),
        React.createElement("div", { style: { display: 'flex', width: '20%', flexDirection: 'row', justifyContent: 'space-around' } }, actions.map((action) => allowed_actions[action]))));
};
export const FileList = ({ documents, setDocuments, indexDocument = 0, setIndexDocument, onViewDocument, onDeleteFile, style, fileEntryActions, }) => {
    const onChangeDocument = (document) => {
        setDocuments(documents.map((doc) => (doc.id === document.id ? { ...doc, isExcluded: !document.isExcluded } : doc)));
    };
    return (React.createElement("div", { style: { overflowY: 'auto', ...style } }, documents.length > 0 &&
        documents.map((doc, index) => {
            return (React.createElement(FileEntry, { key: index, document: doc, onChangeDocument: onChangeDocument, index: index, setIndexDocument: setIndexDocument, onView: onViewDocument, onDelete: onDeleteFile, viewMode: indexDocument === index, actions: fileEntryActions }));
        })));
};
